import React from 'react';

export default props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23.974" height="21.597" viewBox="0 0 23.974 21.597" className={props.className}>
            <path id="heart001_-_E034" data-name="heart001 - E034" d="M-.654-45.96a7,7,0,0,0-5.059,2.194,7,7,0,0,0-5.059-2.194A6.881,6.881,0,0,0-17.7-39.113a6.923,6.923,0,0,0,1.91,4.774h.02l10.057,9.976,9.874-9.793a6.771,6.771,0,0,0,2.113-4.957A6.881,6.881,0,0,0-.654-45.96Z" transform="translate(17.7 45.96)" fill="#439758"/>
        </svg>
    );
}